import {
  PREPARING_DOWNLOAD_ALL_ATTACHMENTS_LOADING,
  PREPARING_DOWNLOAD_ALL_ATTACHMENTS_SUCCESS,
  PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR,
} from "~/store/action_types";

export const preparingDownloadAllAttachments = (state = false, action) => {
  switch (action.type) {
    case PREPARING_DOWNLOAD_ALL_ATTACHMENTS_LOADING:
      return true;
    case PREPARING_DOWNLOAD_ALL_ATTACHMENTS_SUCCESS:
    case PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR:
      return false;
    default:
      return state;
  }
};
